import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'
import { ProductosSearchProps } from './productos.service'

export const getImagenes = async (
  {
    pagina,
    pageSize,
    codLocal,
    codRubro,
    nombreProducto,
    soloActivos,
    publicadoDesde,
    publicadoHasta,
    estado
  }: ProductosSearchProps,
  tenant: ITenant
) => {
  let url = `/${tenant.path}/productos/buscador-imagenes?pageNumber=${pagina}&pageSize=${pageSize}&`
  if (codLocal) url += `codLocal=${codLocal}&`
  if (codRubro) url += `codRubro=${codRubro}&`
  if (nombreProducto) url += `nombre-producto=${nombreProducto}&`
  if (publicadoDesde) url += `fecha-publicacion-desde=${publicadoDesde}&`
  if (publicadoHasta) url += `fecha-publicacion-hasta=${publicadoHasta}&`
  if (soloActivos) url += `solo-activos=${soloActivos}`
  if (estado) url += `estado=${estado}`

  return await axiosInstanceMain.get(url)
}

export const sincronizar = async (
  tenant: ITenant,
  limit: number,
  idFoto: number,
  idProducto: number,
  modelo: string,
  codRubro?: string,
  codLocal?: string,
  soloActivos?: boolean
) => {
  let url = `${tenant.path}/buscador-imagenes/index-pending?limit=${limit}&`
  const params: string[] = []

  idFoto && params.push(`idFotoProducto=${idFoto}`)
  idProducto && params.push(`idProducto=${idProducto}`)
  codRubro && params.push(`codRubro=${codRubro}`)
  codLocal && params.push(`codLocal=${codLocal}`)
  modelo === 'nova' && params.push(`modelo=${modelo}`)
  soloActivos && params.push(`solo-activos=${soloActivos}`)

  url += params.join('&')

  return await axiosInstanceMain.post(url)
}

export const deleteCaptions = async (tenant: ITenant, idFoto: number, idProducto: number) => {
  let url = `${tenant.path}/buscador-imagenes/caption?`
  const params: string[] = []

  idFoto && params.push(`idFotoProducto=${idFoto}`)
  idProducto && params.push(`idProducto=${idProducto}`)

  url += params.join('&')

  return await axiosInstanceMain.delete(url)
}
